import { IPwaPreviewConfig } from '@adminPortal/_common/_interfaces/IPwaPreviewConfig';
import { DIALOG_DATA } from '@angular/cdk/dialog';
import { Component, inject, Inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { TranslatePipe } from '@ngx-translate/core';
import { IconComponent } from '@adminPortal/_common/components/icon/icon.component';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-pwa-activated-modal',
  imports: [TranslatePipe, IconComponent],
  templateUrl: './pwa-activated-modal.component.html',
  styleUrl: './pwa-activated-modal.component.scss',
})
export class PwaActivatedModalComponent {
  private toastr = inject(ToastrService);
  constructor(
    public dialogRef: MatDialogRef<PwaActivatedModalComponent>,
    @Inject(DIALOG_DATA)
    public data: {
      pwa: IPwaPreviewConfig;
      isJustActivated: boolean;
    }
  ) {}

  public close(): void {
    this.dialogRef.close();
  }

  public copyLink() {
    navigator.clipboard.writeText(this.data.pwa.installUrl || '');
    this.toastr.success('Copied!', '', { timeOut: 2000 });
  }
}
